import React, {Fragment} from "react";
import styles from './Meet.module.css';

const Meet = (props) => {
    return (
        <Fragment>
            <div className={styles.content}>
                <img src={props.photo} alt="Team member"/>
                <p className={styles.about}>{props.about}</p>
            </div>
        </Fragment>
    )
}

export default Meet;